var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcMail28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.037 5.078C2 6.22 2 7.73 2 10.746v6.508c0 3.016 0 4.525 1.037 5.668 1.038 1.144 2.402 1.277 5.13 1.543 1.693.165 3.667.285 5.833.285 2.166 0 4.14-.12 5.834-.285 2.727-.266 4.091-.399 5.129-1.543C26 21.78 26 20.27 26 17.254v-6.508c0-3.016 0-4.525-1.037-5.668-1.038-1.144-2.402-1.277-5.13-1.543A60.283 60.283 0 0 0 14 3.25c-2.166 0-4.14.12-5.834.285-2.727.266-4.091.399-5.129 1.543Zm4.35 2.212a1.5 1.5 0 0 0-1.774 2.42l5.726 4.199.052.038c.382.28.764.56 1.116.761.402.229.892.432 1.493.432.6 0 1.091-.203 1.493-.432.352-.2.734-.48 1.116-.761l.052-.038 5.726-4.2a1.5 1.5 0 1 0-1.774-2.419l-5.726 4.2c-.456.334-.696.507-.88.611l-.007.005-.008-.005c-.183-.104-.423-.277-.879-.612L7.387 7.29Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMail28);
export default __webpack_public_path__ + "static/media/ic_mail28.a8085c2e.svg";
export { ForwardRef as ReactComponent };